// @flow
import {fromJS, List, Map} from 'immutable';
import getQuestionDifficultiesFromQuestionSets from 'lib/getQuestionDifficultiesFromQuestionSets';
import getQuestionDifficultyTotalsFromList from 'lib/getQuestionDifficultyTotalsFromList';
import type {QuestionSet as QuestionSetModelV1} from 'resources/GeneratedModels/QuestionSet/QuestionSetModel.v1';

export default function createAssignmentMetadataFromTopicMetadata(
  questionSets: List<QuestionSetModelV1>
): Map<string, *> {
  const subject = questionSets.first().getSubject();
  const guideLevelPath = questionSets.first().getGuideLevelPath();
  const breadcrumbs = guideLevelPath.reduce(
    (breadcrumbs, guideLevel) => {
      breadcrumbs.push({
        name: guideLevel.getName(),
        url: `/learn/${subject.getUrlSlug()}/${guideLevel.getUrlSlug()}?page=1`
      });
      return breadcrumbs;
    },
    [
      {
        name: subject.getName(),
        url: `/${subject.getUrlSlug()}`
      }
    ]
  );

  const questionDifficulties = getQuestionDifficultiesFromQuestionSets(questionSets);

  const questionDifficultyTotals = getQuestionDifficultyTotalsFromList(questionDifficulties);

  const assignmentData = new Map({
    breadcrumbs: fromJS(breadcrumbs),
    questionDifficultyTotals,
    questionSetList: questionSets
  });

  return assignmentData;
}
